const UTILS = {
  async GetCart() {
    return await fetch('/cart.js').then(res => res.json());
  }
};
document.addEventListener('alpine:init', () => {
  Alpine.data('RebuyCartCustom', () => ({
    RebuyCart: null,
    init() {
      let am = this;
      document.addEventListener('rebuy:cart.change', am.CleanupLineTitles.bind(am));
      document.addEventListener('rebuy:smartcart.ready', am.CleanupLineTitles.bind(am));
      am.CleanupLineTitles();

      document.addEventListener('rebuy:smartcart.init', (e) => {
        // console.log(e);
        am.RebuyCart = window.Rebuy.Cart;
        am.CheckTotal(am.RebuyCart.cart);
      });

      // on item qty change
      document.addEventListener('rebuy:smartcart.line-item-decrease', am.CartLineUpdate.bind(am));
      document.addEventListener('rebuy:smartcart.line-item-increase', am.CartLineUpdate.bind(am));

      // on item add
      document.addEventListener('rebuy:cart.add', (e) => {
        // console.log(e);
        // pass smart cart line item, to use getItemLineNumber()
        setTimeout(() => {
          am.CheckTotal(e.detail.cart.cart);
          e.detail.item = window.Rebuy.SmartCart.items()[0];
          am.CartLineUpdate(e);
        }, 250);
      });

      // on cart update, check total requirements
      document.addEventListener('rebuy:cart.change', (e) => {
        // console.log(e);
        setTimeout(() => {
          am.CheckTotal(e.detail.cart.cart);
          am.CleanupLineTitles();
        }, 250);
      });
    },
    CartLineUpdate(e) {
      // console.log(e);
      let am = this;
      let item = e.detail.item;
      let option_case = item.options_with_values.find(o => o.name == 'casepack');
      if (option_case) {
        let case_qty = parseInt(option_case.value);
        let qty = item.quantity;
        let new_qty;
        switch(e.type) {
          case 'rebuy:smartcart.line-item-decrease':
            new_qty = qty - (qty % case_qty) + (case_qty * -1);
            break;
          case 'rebuy:smartcart.line-item-increase':
            new_qty = qty - (qty % case_qty) + (case_qty * 1);
            break;
          default: 
            new_qty = qty;
        }
        if (new_qty ==  qty) return;
        am.UpdateLineItemQty(item, new_qty);  
      }
    },
    UpdateLineItemQty(item, new_qty) {
      let am = this;
      am.RebuyCart.setItemQuantity(item, new_qty);
    },

    async CheckTotal() {
      let cart = await UTILS.GetCart();
      let cart_total = cart.items_subtotal_price;
      let isBelow_Min = cart_total < 15000;
      let $rebuy_min_req = document.querySelectorAll('.rebuy_min_req');

      if ($rebuy_min_req.length == 0) {
        document.querySelectorAll('.rebuy-cart__checkout-button').forEach(($checkout_btn) => {
          $checkout_btn.disabled = isBelow_Min;
          if (isBelow_Min) {
            $checkout_btn.insertAdjacentHTML('afterend', '<div style="width: 100%; text-align: center;" class="rebuy_min_req error-message">Minimum order of $150 required</div>');
          }
        });  
      }

      if (!isBelow_Min) {
        $rebuy_min_req.forEach($msg => {
          $msg.remove();
        });
      }
    },

    CleanupLineTitles() {
      // console.log(document.querySelectorAll('.rebuy-cart__flyout-item-variant-title'));
      document.querySelectorAll('.rebuy-cart__flyout-item-variant-title').forEach(($lineTitle) => {
        $lineTitle.innerText = $lineTitle.innerText.replace('wholesale /', '');
      });
    }
  }));
});